export default __webpack_public_path__ + "static/logo_WODY-POLSKIE_pl-poziom-a50b687dc302a444ce481f5c394e5b37.jpg";